import ProgressBar from '@ramonak/react-progress-bar';
import React from 'react';
import '../Css/Skill.css'
import { FaReact } from "@react-icons/all-files/fa/FaReact";
import { FaGithub } from "@react-icons/all-files/fa/FaGithub";
import { SiJavascript} from "@react-icons/all-files/si/SiJavascript";
import { SiFirebase} from "@react-icons/all-files/si/SiFirebase";
import { SiRedux} from "@react-icons/all-files/si/SiRedux";
import { SiNetlify} from "@react-icons/all-files/si/SiNetlify";
import {SiTailwindcss} from "@react-icons/all-files/si/SiTailwindcss";

import { DiMongodb} from "@react-icons/all-files/di/DiMongodb";
import {FaNodeJs} from "@react-icons/all-files/fa/FaNodeJs";
const Skill = () => {
    return (
        <>
        <div className='skill-container pb-10 lg:mt-5 ' id='skill'>
          <div className='flex justify-center mr-3 lg:mr-0 mb-8 lg:mb-12'>

             <h2 className='skill-title  font-bold lg:text-2xl bg-slate-700 inline-block p-2 rounded-lg '>Technologies & Tools</h2>
          </div>
          <div className='skill-card-container bg-slate-700 '>
             <div className=' hover:shadow-lg hover:px-4  skill-card'>
             <p> <SiJavascript className='text-yellow-500 lg:text-6xl'></SiJavascript></p>
            <h1 className='text-white lg:text-2xl font-bold '>Javascript</h1>
          
          </div>
             
            <div className='hover:shadow-lg hover:px-4 skill-card'> 
              <p> <FaNodeJs className='lg:text-6xl text-blue-500'></FaNodeJs></p>
           <h1 className='text-white lg:text-2xl font-bold'>Node JS</h1></div>
            <div className=' hover:shadow-lg hover:px-4 skill-card'> 
              <p> <FaReact className='lg:text-6xl text-blue-500'></FaReact></p>
           <h1 className='text-white lg:text-2xl font-bold'>React JS</h1></div>
            <div className=' hover:shadow-lg hover:px-4 skill-card'> 

             <p>  <SiFirebase className='lg:text-6xl text-blue-500'></SiFirebase></p>
           <h1 className='text-white lg:text-2xl font-bold'>Firebase</h1></div>
            <div className='hover:shadow-lg hover:px-4 skill-card'> 
              <p> <DiMongodb className='lg:text-6xl text-blue-500'></DiMongodb></p>
           <h1 className='text-white lg:text-2xl font-bold'>MongoDB</h1></div>
            <div className=' hover:shadow-lg hover:px-4 skill-card'> 
           <p> <SiRedux className='lg:text-6xl text-blue-500'></SiRedux></p>
           <h1 className='text-white lg:text-2xl font-bold'>Redux</h1></div>
            <div className=' hover:shadow-lg hover:px-4 skill-card'> 
               <p><SiTailwindcss className='lg:text-6xl text-blue-500'></SiTailwindcss></p>
           <h1 className='text-white lg:text-2xl font-bold'>TailwindCss</h1></div>
            <div className=' hover:shadow-lg hover:px-4 skill-card'> 
              <p> <FaGithub className='lg:text-6xl text-blue-500'></FaGithub></p>
           <h1 className='text-white lg:text-2xl font-bold'>GitHub</h1></div>
            <div className=' hover:shadow-lg hover:px-4 skill-card'> 
               <p><SiNetlify className='lg:text-6xl text-blue-500'></SiNetlify></p>
           <h1 className='text-white lg:text-2xl font-bold'>Netlify</h1></div>
         
         
          </div>
         
           
        </div>
        
        </>
    );
};

export default Skill;